import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UIAlert from 'UIComponents/alert/UIAlert';
import UIButtonWrapper from 'UIComponents/layout/UIButtonWrapper';
import UIButton from 'UIComponents/button/UIButton';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import UILink from 'UIComponents/link/UILink';
import UIModal from 'UIComponents/dialog/UIModal';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import H2 from 'UIComponents/elements/headings/H2';
import FloatingAlertStore from 'UIComponents/alert/FloatingAlertStore';
import * as emailsSelectors from 'ContentData/selectors/emails';
import * as EmailsActions from 'ContentData/actions/Emails';
import { convertLegacyFollowupEmail } from 'ContentData/api/Emails';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function mapStateToProps(state, props) {
  const {
    emailId
  } = props;
  return {
    email: emailId ? emailsSelectors.getEmail(state, {
      id: emailId
    }) : null,
    hasFetchedIsLegacyEmailConvertible: emailsSelectors.getHasFetchedIsLegacyEmailConvertible(state, {
      id: emailId
    }),
    isLegacyEmailConvertible: emailId ? emailsSelectors.getIsLegacyEmailConvertible(state, {
      id: emailId
    }) : false
  };
}
const mapDispatchToProps = {
  fetchIsLegacyEmailConvertible: EmailsActions.fetchIsLegacyEmailConvertible
};
const connector = connect(mapStateToProps, mapDispatchToProps);
const i18nKey = key => `ContentComponents.cmv2.fields.form.formWorkflowDependencies.followupEmailWorkflows.legacyEmailIsSelectedAlert.${key}`;
const UpgradeEmailModal = ({
  emailName = '',
  isUpgrading,
  onClose,
  onUpgradeEmail
}) => {
  return /*#__PURE__*/_jsxs(UIModal, {
    use: "danger",
    children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
      children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: onClose
      }), /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('upgradeModal.header')
        })
      })]
    }), /*#__PURE__*/_jsx(UIDialogBody, {
      children: /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: i18nKey('upgradeModal.message'),
          options: {
            emailName
          }
        })
      })
    }), /*#__PURE__*/_jsxs(UIDialogFooter, {
      children: [/*#__PURE__*/_jsx(UILoadingButton, {
        loading: isUpgrading,
        onClick: onUpgradeEmail,
        use: "danger",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('upgradeModal.upgrade')
        })
      }), /*#__PURE__*/_jsx(UIButton, {
        onClick: onClose,
        use: "tertiary-light",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('upgradeModal.cancel')
        })
      })]
    })]
  });
};
const RemoveEmailModal = ({
  onClose,
  onRemoveEmail
}) => {
  return /*#__PURE__*/_jsxs(UIModal, {
    use: "danger",
    children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
      children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: onClose
      }), /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('removeModal.header')
        })
      })]
    }), /*#__PURE__*/_jsx(UIDialogBody, {
      children: /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: i18nKey('removeModal.message')
        })
      })
    }), /*#__PURE__*/_jsxs(UIDialogFooter, {
      children: [/*#__PURE__*/_jsx(UIButton, {
        "data-selenium": "clear-legacy-followup-email-confirm-button",
        onClick: onRemoveEmail,
        use: "danger",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('removeModal.upgrade')
        })
      }), /*#__PURE__*/_jsx(UIButton, {
        onClick: onClose,
        use: "tertiary-light",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('removeModal.cancel')
        })
      })]
    })]
  });
};
const showUpgradeError = () => {
  FloatingAlertStore.addAlert({
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey('upgradeErrorAlert.message')
    }),
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey('upgradeErrorAlert.title')
    }),
    type: 'danger'
  });
};
const LegacyEmailAlert = ({
  clearLegacyFollowupEmail,
  fetchIsLegacyEmailConvertible,
  hasFetchedIsLegacyEmailConvertible,
  isLegacyEmailConvertible,
  email,
  emailId,
  onChangeFollowupEmailEvent,
  onFollowupEmailIdChange
}) => {
  const [isUpgradeModalOpen, setIsUpgradeModalOpen] = useState(false);
  const [isUpgrading, setIsUpgrading] = useState(false);
  const [isRemoveModalOpen, setIsRemoveModalOpen] = useState(false);
  const clearLegacyAndSetFollowupEmailId = () => {
    clearLegacyFollowupEmail(() => {
      onFollowupEmailIdChange(emailId);
      setIsUpgrading(false);
      setIsUpgradeModalOpen(false);
    });
  };
  const onUpgradeEmail = () => {
    setIsUpgrading(true);
    if (!email) {
      setIsUpgrading(false);
      showUpgradeError();
      return;
    }
    if (email.emailType === 'FOLLOWUP_EMAIL') {
      convertLegacyFollowupEmail(email).then(response => {
        const {
          errors = [],
          incomplete
        } = response;
        if (errors.length || incomplete) {
          setIsUpgrading(false);
          showUpgradeError();
          return;
        }
        if (onChangeFollowupEmailEvent) {
          onChangeFollowupEmailEvent('form-followup-email-upgrade-legacy');
        }
        clearLegacyAndSetFollowupEmailId();
      }).catch(() => {
        setIsUpgrading(false);
        showUpgradeError();
      });
    } else {
      clearLegacyAndSetFollowupEmailId();
    }
  };
  const onRemoveEmail = () => {
    if (onChangeFollowupEmailEvent) {
      onChangeFollowupEmailEvent('form-followup-email-remove-legacy');
    }
    clearLegacyFollowupEmail();
    setIsRemoveModalOpen(false);
    return;
  };
  useEffect(() => {
    if (email && !hasFetchedIsLegacyEmailConvertible) {
      fetchIsLegacyEmailConvertible(email.id).catch(err => {
        throw err;
      });
    }
  }, [email, hasFetchedIsLegacyEmailConvertible, fetchIsLegacyEmailConvertible]);
  return /*#__PURE__*/_jsx(UIAlert, {
    className: "m-bottom-3",
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey('title')
    }),
    type: "warning",
    children: /*#__PURE__*/_jsxs(UIButtonWrapper, {
      children: [/*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: i18nKey(isLegacyEmailConvertible ? 'message_jsx' : 'notUpgradableMessage_jsx'),
        options: {
          href: 'https://knowledge.hubspot.com/forms/set-up-and-style-forms-on-hubspot-pages#configure-your-form-automation'
        },
        elements: {
          Link: UILink
        }
      }), isUpgradeModalOpen && /*#__PURE__*/_jsx(UpgradeEmailModal, {
        emailName: email && email.name,
        isUpgrading: isUpgrading,
        onClose: () => setIsUpgradeModalOpen(false),
        onUpgradeEmail: onUpgradeEmail
      }), isLegacyEmailConvertible && /*#__PURE__*/_jsx(UIButton, {
        "data-selenium": "upgrade-legacy-followup-email-button",
        onClick: () => setIsUpgradeModalOpen(true),
        size: "extra-small",
        use: "tertiary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('upgradeButton')
        })
      }), isRemoveModalOpen && /*#__PURE__*/_jsx(RemoveEmailModal, {
        onClose: () => setIsRemoveModalOpen(false),
        onRemoveEmail: onRemoveEmail
      }), /*#__PURE__*/_jsx(UIButton, {
        "data-selenium": "clear-legacy-followup-email-button",
        onClick: () => setIsRemoveModalOpen(true),
        size: "extra-small",
        use: "tertiary-light",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('removeButton')
        })
      })]
    })
  });
};
export default connector(LegacyEmailAlert);